var _path, _rect, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToiletDoorSwing = function SvgIcToiletDoorSwing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4.234 26.984h24.03"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.713,
    height: 20.381,
    x: 7.914,
    y: 6.604,
    fill: "#67AEFF",
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M7.875 8.272a2 2 0 0 1 1.268-1.86l5.398-2.122a2 2 0 0 1 2.732 1.861V27.04a2 2 0 0 1-2.566 1.918l-5.397-1.59a2 2 0 0 1-1.435-1.92z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.855,
    cy: 16.372,
    r: 1.3,
    fill: "currentColor"
  })));
};
export default SvgIcToiletDoorSwing;